import { useClientPortalAPI, useRequest } from "@certn/api";
import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import { TextField } from "@certn/cascadia-react/components/inputs/text-field/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  id: string;
  tagName: string;
}
export function EditTagModal(props: Props) {
  const { isOpen, onClose, id, tagName } = props;
  const { t } = useTranslation();
  const [newTagName, setNewTagName] = useState<string>(tagName);
  const request = useRequest();
  const { mutate } = useClientPortalAPI(`/api/internal/client-portal/tags/`);

  async function submitEditTag(): Promise<void> {
    await request(`/api/internal/client-portal/tags/${id}/edit/`, {
      method: "POST",
      body: JSON.stringify({ name: newTagName }),
    });
    mutate();
    onClose();
  }
  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Edit tag")}</DialogHeader>
        <DialogContent>
          <TextField
            label={t("Tag name")}
            testID="edit-tag-field"
            isRequired
            onChange={(value) => setNewTagName(value)}
            value={newTagName}
          />
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose}>{t("Close")}</BasicButton>
          <PrimaryButton onPress={() => submitEditTag()}>
            {t("Save")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
